import { useReducer } from "react";
import { LangType } from "src/hooks/useLocales";
import { RedirectType } from "src/types/apps";

export const initial: State = {
	redirectSelected: undefined,
	languageSelected: undefined,
	themeMode: "light",
	positionType: "FUND",
	type: ""
};

export interface State {
	redirectSelected?: RedirectType;
	languageSelected?: LangType;
	themeMode: string;
	positionType: string;
	type: string;
}

enum ActionType {
	setRedirect = "setRedirect",
	setLanguage = "setLanguage",
	setThemeMode = "setThemeMode",
	setPositionType = "setPositionType"
}

interface Action {
	type: string;
	val: RedirectType | LangType | string;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.setRedirect:
			return { ...state, redirectSelected: action.val as RedirectType };
		case ActionType.setLanguage:
			return { ...state, languageSelected: action.val as LangType };
		case ActionType.setThemeMode:
			return { ...state, themeMode: action.val as string };
		case ActionType.setPositionType:
			return { ...state, positionType: action.val as string };
		default:
			throw new Error();
	}
}

export default function useRedirectCardActionsStore(currentLang: LangType, type: string) {
	const [state, dispatch] = useReducer(reducer, {
		...initial,
		languageSelected: currentLang,
		type
	});

	const actions = {
		setRedirect: (val: RedirectType) => dispatch({ type: ActionType.setRedirect, val }),
		setLanguage: (val: LangType) => dispatch({ type: ActionType.setLanguage, val }),
		setThemeMode: (val: string) => dispatch({ type: ActionType.setThemeMode, val }),
		setPositionType: (val: string) => dispatch({ type: ActionType.setPositionType, val })
	};

	return [state, actions] as const;
}
